export default __webpack_public_path__ + "static/image-4-card-section-b6f2c722a487f5f9bb5316fef7537ab7.png";